import dayjs from 'dayjs'
import CONFIG from '../../constants/config'

export enum ExcelTaskType {
  ATTENDANCE_DAILY = 0,
  ATTENDANCE_WEEKLY_MONTHLY = 1,
  PHOTO_STATISTICS = 2,
  ALL_PHOTO_EXCEL = 3,
  RECTIFICATION = 4
}

export type ExcelTask = {
  groupID?: string
  operateTime: string
  exportType: ExcelTaskType
  membersNum: number
  startDate: string
  endDate: string
  finished: number
  fileName: string
  url: string
  contentNumber: number
  fromPlace?: string // 添加来源标识
}

type ExportExcelTask = {
  groupID?: string
  membersNum: number
  exportType: ExcelTaskType
  startDate: string
  endDate: string
  finished: number
  fileName: string
  url: string
  contentNumber: number
  fromPlace?: string // 添加来源标识
}

export default function ({
  groupID,
  membersNum,
  exportType,
  startDate,
  endDate,
  finished,
  fileName,
  url,
  contentNumber,
  fromPlace
}: ExportExcelTask) {
  let excelTasks = localStorage.getItem('excelTasks')
  let tasks: ExcelTask[] = []
  if (excelTasks) {
    try {
      tasks = JSON.parse(excelTasks)
    } catch (e) {
      console.log('解析Excel任务列表失败')
    }
  }

  tasks.push({
    groupID,
    operateTime: dayjs().format(CONFIG.timeFormat),
    exportType,
    membersNum,
    startDate,
    endDate,
    finished,
    fileName,
    url,
    contentNumber,
    fromPlace
  })

  localStorage.setItem('excelTasks', JSON.stringify(tasks))
}
